<template>
  <button class="start-button start-chat-button">
    <!-- <i class="material-icons" aria-hidden="true">sms</i> -->
    <message-processing />
  </button>
</template>

<script>
import { mapState } from 'pinia'
import { useWidgetStore } from '@/store'
import MessageProcessing from 'vue-material-design-icons/MessageProcessing.vue'
export default {
  name: 'StartButton',
  computed: {
    ...mapState(useWidgetStore, ['brandingColor'])
  },
  components: {
    MessageProcessing
  }
}
</script>

<style scoped lang="sass">
.start-button
  width: 64px
  height: 64px
  background-color: v-bind('brandingColor')
  border-radius: 50%
  color: #fff
  outline: none
  border: none
  cursor: pointer
  position: fixed
  right: 30px
  bottom: 30px
  z-index: 11
  padding: 1px 6px

@media screen and (max-width: 720px)
.start-chat-button
   z-index:0
</style>
